export default __webpack_public_path__ + "static/media/washing-machine.e0b319be.svg";